export default __webpack_public_path__ + "static/media/text_icon.1447cf3c.svg";